import { NavigationEvent } from "../types";

export const exitApp = () => {
  window.dispatchEvent(new CustomEvent(NavigationEvent.appExited));
};
